// extracted by mini-css-extract-plugin
export default {"content":"Styles_content__HVpOZ"};